import Shortcode from "src/libs/useful/shortcode"
import { PersonContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import ImagePrimitive from "./ImagePrimitive"
import Background from "../section/Background"

/* Protopia Ecosystem component */ 
const PersonPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: PersonContent = ( props.primitive || {} ) as PersonContent  
    return <div className={`landing-person-primitive pe-primitive-container ${primitive.isVertical ? "vertical" : ""}`} style={ primitive.style } >
        <ImagePrimitive 
            primitive={{
                id: `avatar-${primitive.id}`,
                hover_size: 4,
                position: {
                    width: primitive.avatarWidth || 90,
                    height: primitive.avatarHeight || 90,
                },
                border: primitive?.border,
                data: {
                    src: primitive?.user?.avatar,
                }
            }} 
        />
        <div className={`landing-person-primitive-descr-container `} data-primitive-type={primitive["data-primitive-type"]}>
            {
                !!primitive?.user?.first_name && !!primitive?.user?.last_name &&
                <div className="landing-person-primitive-last_name" style={{...primitive.firstNameStyle}}>
                    { primitive?.user?.first_name }
                </div>
            }
            {
                !!primitive?.user?.first_name &&
                <div className="landing-person-primitive-first_name" style={{...primitive.lastNameStyle}}>
                    { primitive?.user?.last_name }
                </div>
            }
            {
                !primitive?.user?.first_name &&
                    <div className="landing-person-primitive-display_name" style={{...primitive.displayNameStyle}}>
                        { primitive?.user?.display_name }
                    </div>
            }
            <Shortcode 
                content={ primitive?.user ? primitive?.user?.description : "No user present" } 
                className="landing-person-primitive-descr"
                style={{...primitive.descriptionStyle}}
            />  
        </div>
        <div
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                opacity: 1,
                zIndex: -1
            }}
        >
            <Background section={primitive} />
        </div>
    </div>
}
export default PersonPrimitive